"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
const redux_1 = require("redux");
const vehicles_reducer_1 = require("./vehicles.reducer");
const lastVisitedVehicleIds_reducer_1 = require("./lastVisitedVehicleIds.reducer");
const matchingVehicleIdsFromDealerReducer_1 = require("./matchingVehicleIdsFromDealerReducer");
const matchingVehicleIds_reducer_1 = require("./matchingVehicleIds.reducer");
const favoriteVehicleIds_reducer_1 = require("./favoriteVehicleIds.reducer");
const comparedVehicleIds_reducer_1 = require("./comparedVehicleIds.reducer");
const comparedVehicles_reducer_1 = require("./comparedVehicles.reducer");
const country_reducer_1 = require("./country.reducer");
const totalCount_reducer_1 = require("./totalCount.reducer");
const filterOptions_reducer_1 = require("./filterOptions.reducer");
const resultVehicleIdsReducer_1 = require("./resultVehicleIdsReducer");
const sorting_reducer_1 = require("./sorting.reducer");
const ui_reducer_1 = require("./ui.reducer");
const svdVersion_reducer_1 = require("./svdVersion.reducer");
const filters_reducer_1 = require("./filters.reducer");
const filterParams_reducer_1 = require("./filterParams.reducer");
const aoz_reducer_1 = require("./aoz.reducer");
const tracking_reducer_1 = require("./tracking.reducer");
const financing_reducer_1 = require("./financing.reducer");
const scPatternMatching_reducer_1 = require("./scPatternMatching.reducer");
const pendingIDs_reducer_1 = require("./pendingIDs.reducer");
const entryUrl_reducer_1 = require("./entryUrl.reducer");
const filterGroups_reducer_1 = require("./filterGroups.reducer");
exports.rootReducer = (0, redux_1.combineReducers)({
    aoz: aoz_reducer_1.aozReducer,
    compareVehicleIds: comparedVehicleIds_reducer_1.comparedVehicleIdsReducer,
    compareVehicles: comparedVehicles_reducer_1.comparedVehiclesReducer,
    country: country_reducer_1.countryReducer,
    favoriteVehiclesIds: favoriteVehicleIds_reducer_1.favoriteVehicleIdsReducer,
    financing: financing_reducer_1.financingReducer,
    filterOptions: filterOptions_reducer_1.filterOptionsReducer,
    filterParams: filterParams_reducer_1.filterParamsReducer,
    filters: filters_reducer_1.filtersReducer,
    filterGroups: filterGroups_reducer_1.filterGroupsReducer,
    lastVisitedVehicleIds: lastVisitedVehicleIds_reducer_1.lastVisitedVehicleIdsReducer,
    matchingVehicleIdsFromDealer: matchingVehicleIdsFromDealerReducer_1.matchingVehicleIdsFromDealerReducer,
    matchingVehicleIds: matchingVehicleIds_reducer_1.matchingVehicleIdsReducer,
    pendingIDs: pendingIDs_reducer_1.pendingIDsReducer,
    resultVehicleIds: resultVehicleIdsReducer_1.resultVehicleIdsReducer,
    sorting: sorting_reducer_1.sortingReducer,
    svdVersion: svdVersion_reducer_1.svdVersionReducer,
    totalCount: totalCount_reducer_1.totalCountReducer,
    entryUrl: entryUrl_reducer_1.entryUrlReducer,
    tracking: tracking_reducer_1.trackingReducer,
    ui: ui_reducer_1.uiReducer,
    vehicles: vehicles_reducer_1.vehiclesReducer,
    patternId: scPatternMatching_reducer_1.patternMatchingReducer,
});
//# sourceMappingURL=index.js.map